import { render, staticRenderFns } from "./important-notifications.vue?vue&type=template&id=4a9bfa06"
import script from "./important-notifications.js?vue&type=script&lang=js&external"
export * from "./important-notifications.js?vue&type=script&lang=js&external"
import style0 from "./important-notifications.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports